import { useQuery } from "@tanstack/react-query";
import phoneApi from "../../api/phoneApi";

export const useGetAllPhoneNumber = (page: number, limit: number) => {
    return useQuery({
        queryKey: ["phone-numbers", page, limit],
        queryFn: () => phoneApi.getPhone(page,limit),
    });
};
